

const hs205 = {
  label: "Loan Details",
  pageLabel: "Loan Details",
  starting: true,
  url: "hs205",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Branch",
      label: "Parent Branch",
      name: "branch",
      description: "Enter Branch"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "branch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      data: "branch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product1",
          value: "product1"
        },
        {
          label: "product2",
          value: "product2"
        },
        {
          label: "product3",
          value: "product3"
        }
      ],
      placeHolder: "Product",
      //   label: "Branch Code",
      name: "product",
      description: "Select product code"
    },
    {
      inputType: "showdata",
      data: "product",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Account Number",
      label: "Account Number1",
      name: "",
      description: "Enter Account Number"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "account number-1",
          value: "account number-1"
        },
        {
          label: "account number-2",
          value: "account number-2"
        },
        {
          label: "account number-3",
          value: "account number-3"
        }
      ],
      placeHolder: "Account Number",
      //   label: "Branch Code",
      name: "accountNumber",
      description: "Select account number"
    },
    {
      inputType: "showdata",
      data: "accountNumber",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "basicinfo",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Sanction Date",
      label: "Sanction Date",
      name: "",
      description: "Sanction Date"
    },
    {
      inputType: "date",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Sanction Date",
      name: "SanctionDate",
      description: "Sanction Date"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Resolution Number",
      label: "Resolution No",
      name: "",
      description: "Enter Resolution Number"
    },
    {
      inputType: "numberonly",
      isRequired: true,
      tab: "filter",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Enter Resolution Number",
      label: "",
      name: "resolutionNumber",
      description: "Enter Resolution Number"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Sanction Amount",
      label: "Sanction Amount",
      name: "",
      description: "Enter Sanction Amount"
    },
    {
      inputType: "numberonly",
      isRequired: true,
      tab: "filter",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Enter Sanction Amount",
      label: "",
      name: "sanctionAmount",
      description: "Enter Sanction Amount"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Disbursed Amount",
      label: "Disbursed Amount",
      name: "",
      description: "Enter Disbursed Amount"
    },
    {
      inputType: "numberonly",
      isRequired: true,
      tab: "filter",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Enter Disbursed Amount",
      label: "",
      name: "DisbursedAmount",
      description: "Enter Disbursed Amount"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Purpose",
      label: "Purpose",
      name: "",
      description: "Enter Purpose"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "purpose-1",
          value: "purpose-1"
        },
        {
          label: "purpose-2",
          value: "purpose-2"
        },
        {
          label: "purpose-3",
          value: "purpose-3"
        }
      ],
      placeHolder: "purpose",
      //   label: "Branch Code",
      name: "purpose",
      description: "Select account number"
    },
    {
      inputType: "showdata",
      data: "purpose",
      textcolor: "black",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Priority Sector",
      label: "Priority Sector",
      name: "",
      description: "Enter Priority Sector"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Priority sector-1",
          value: "Priority sector-1"
        },
        {
          label: "Priority sector-2",
          value: "Priority sector-2"
        },
        {
          label: "Priority sector-3",
          value: "Priority sector-3"
        }
      ],
      placeHolder: "Priority Sector",
      //   label: "Branch Code",
      name: "PrioritySector",
      description: "Select Priority Sector"
    },
    {
      inputType: "showdata",
      data: "PrioritySector",
      textcolor: "black",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Priority Segment",
      label: "Priority Segment",
      name: "",
      description: "Enter Priority Segment"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Priority Segement-1",
          value: "Priority Segement-1"
        },
        {
          label: "Priority Segement-2",
          value: "Priority Segement-2"
        },
        {
          label: "Priority Segement-3",
          value: "Priority Segement-3"
        }
      ],
      placeHolder: "Priority Segement",
      //   label: "Branch Code",
      name: "PrioritySegement",
      description: "Select Priority Segement"
    },
    {
      inputType: "showdata",
      data: "PrioritySegement",
      textcolor: "black",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Category",
      label: "Category",
      name: "",
      description: "Enter Category"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Category-1",
          value: "Category-1"
        },
        {
          label: "Category-2",
          value: "Category-2"
        },
        {
          label: "Category-3",
          value: "Category-3"
        }
      ],
      placeHolder: "Category",
      //   label: "Branch Code",
      name: "category",
      description: "Select Category"
    },
    {
      inputType: "showdata",
      data: "category",
      textcolor: "black",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "industry Type",
      label: "industry Type",
      name: "",
      description: "Enter industry Type"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Industry Type-1",
          value: "Industry Type-1"
        },
        {
          label: "Industry Type-2",
          value: "Industry Type-2"
        },
        {
          label: "Industry Type-3",
          value: "Industry Type-3"
        }
      ],
      placeHolder: "Industry Type",
      //   label: "Branch Code",
      name: "IndustryType",
      description: "Select Industry Type"
    },
    {
      inputType: "showdata",
      data: "PrioritySegement",
      textcolor: "black",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Health",
      label: "Health",
      name: "",
      description: "Enter Health"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Health-1",
          value: "Health-1"
        },
        {
          label: "Health-2",
          value: "Health-2"
        },
        {
          label: "Health-3",
          value: "Health-3"
        }
      ],
      placeHolder: "Health",
      //   label: "Branch Code",
      name: "health",
      description: "Select Health"
    },
    {
      inputType: "showdata",
      data: "health",
      textcolor: "black",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Sanction By",
      label: "Sanction By",
      name: "",
      description: "Enter Sanction By"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Sanction By-1",
          value: "Sanction By-1"
        },
        {
          label: "Sanction By-2",
          value: "Sanction By-2"
        },
        {
          label: "Sanction By-3",
          value: "Sanction By-3"
        }
      ],
      placeHolder: "Sanction By",
      //   label: "Branch Code",
      name: "sanctionBy",
      description: "Select Sanction By"
    },
    {
      inputType: "showdata",
      data: "sanctionBy",
      textcolor: "black",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Reference By",
      label: "Reference By",
      name: "",
      description: "Enter Reference By"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Reference by-1",
          value: "Reference by-1"
        },
        {
          label: "Reference by-2",
          value: "Reference by-2"
        },
        {
          label: "Reference by-3",
          value: "Reference by-3"
        }
      ],
      placeHolder: "Reference By",
      //   label: "Branch Code",
      name: "ReferenceBy",
      description: "Select Reference By"
    },
    {
      inputType: "showdata",
      data: "ReferenceBy",
      textcolor: "black",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    }
  ]
};

export default hs205;
